export class DamagedTypeConstant {
    static AVARIE_TYPE = {
      container: "CONTAINER",
      craft: "CRAFT",
      vehicle: "VEHICLE",
      bag: "BAG",
      other: "OTHER",
    };
  
    static getAvarieTypeLabel = (type: string) => {
      switch (type) {
        case this.AVARIE_TYPE.container.toLowerCase():
          return "Conteneur";
  
        case this.AVARIE_TYPE.craft.toLowerCase():
          return "Navire";
  
        case this.AVARIE_TYPE.vehicle.toLowerCase():
          return "Véhicule";
  
        case this.AVARIE_TYPE.bag.toLowerCase():
          return "Sacherie";
  
        case this.AVARIE_TYPE.other.toLowerCase():
          return "Autre";
  
        default:
          return "";
      }
    };
  }
  